export default __webpack_public_path__ + "assets/images/3383ddae7b9c3fbd90dd166df24b6d29.png";